import { render } from "./UnNftSetMenu.vue?vue&type=template&id=b07b2644"
import script from "./UnNftSetMenu.vue?vue&type=script&lang=js"
export * from "./UnNftSetMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__